export type UserGroup = {
  groupName: string;
};

export type SelectorCluster = {
  name: string;
  displayName?: string;
  deployable: boolean;
  production: boolean;
  pci: boolean;
  allowedAadGroups?: string[];
};

export enum SelectorView {
  guided = 'guided',
  advanced = 'advanced',
}

export enum Environment {
  prod = 'prod',
  nonprod = 'nonprod',
}

export enum DataClassification {
  pci = 'pci',
  nonpci = 'nonpci',
}
